import { render } from "./FormMiscel.vue?vue&type=template&id=ed4f313a&scoped=true"
import script from "./FormMiscel.vue?vue&type=script&lang=js"
export * from "./FormMiscel.vue?vue&type=script&lang=js"

import "./FormMiscel.vue?vue&type=style&index=0&id=ed4f313a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed4f313a"

export default script